import styled from '@emotion/styled';

type StyledFieldNameProps = {
  onClick:
    | ((event: React.MouseEvent<HTMLHeadingElement, MouseEvent>) => void)
    | undefined;
  disabled: boolean;
};

const StyledFieldName = styled('h4')<StyledFieldNameProps>(({ disabled }) => ({
  marginBottom: 0,
  marginRight: 'auto',
  cursor: disabled ? undefined : 'pointer',
}));

export default StyledFieldName;
